<template>
 <AdminPanelMegogoPackageSellingHistory />
</template>

<script>
import AdminPanelMegogoPackageSellingHistory from '../components/AdminPanelMegogoPackageSellingHistory.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelMegogoPackageSellingHistory
    },
    methods: {},
    mounted() {}
}
</script>
